<div class="comment" fxLayout="column" fxLayoutGap="10px" style="position: relative;">

  <!-- delete button positioned absolute -->
  <div *ngIf="userService.user && comment.frontend_user.id == userService.user.id"
    fxLayout="row" fxLayoutAlign="center center"
    class="trashcan"
    (click)="delete()"
    matTooltip='Kommentar löschen'>
    <i class="fas fa-trash-alt"></i>
  </div>

  <div fxLayout="row">
    <author [profile]="comment.frontend_user" [created_at]="comment.created_at"
    [lightgraymode]="true"></author>
  </div>

  <div fxLayout="row" fxLayoutAlign="left top" style="word-break: break-word;">
    <div [innerHTML]="comment.message"></div>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <like-button [likeable]="comment"></like-button>
  </div>
</div>